<div class="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
  <svg-icon [src]="'maintenance'"></svg-icon>
  <p class="font-secondary font-bold text-9xl mt-8">{{ buildTranslationKey('title') | translate }}</p>
  <div class="font-main text-2xl flex flex-col justify-center items-center text-center max-w-136 gap-5">
    <p>
      {{ buildTranslationKey('info') | translate }}
    </p>
    <p>
      {{ buildTranslationKey('apology') | translate }}
    </p>
  </div>
</div>
